import type { DocumentEmailHistoryType } from '@econtractor/types';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import EmailHistoryTableBody from './EmailHistoryTableBody';

interface EmailHistoryTableProps {
    rows: DocumentEmailHistoryType[] | null;
    error: boolean;
}

const EmailHistoryTable = ({ rows, error }: EmailHistoryTableProps) => {
    const { t } = useTranslation(['Objects', 'common']);

    return (
        <div className="mt-4 mb-3">
            <h6>{t('documents.emailHistory.title')}</h6>
            {error ? <div className="text-danger">{t('common:messError')}</div> : rows === null ? <ESpinner /> : (
                <div className="table-responsive">
                    <Table size="sm" className="DocumentEmailHistoryTable mb-0 align-middle">
                        <thead>
                            <tr>
                                <td className="head-username">{t('documents.emailHistory.who')}</td>
                                <td className="head-date">{t('documents.emailHistory.when')}</td>
                                <td className="head-email">{t('documents.emailHistory.to')}</td>
                                <td className="head-comment" />
                            </tr>
                        </thead>
                        <EmailHistoryTableBody rows={rows} />
                    </Table>
                </div>
            )}
        </div>
    );
};

export default EmailHistoryTable;
